import {
  ArticleFooterContributorInfo,
  ArticleFooterContributorInfoProps,
} from "design-system/components/pages/article-page/article-footer/article-footer-contributor-info";

export interface ContributorProps {
  [key: string]: Array<ArticleFooterContributorInfoProps>;
}

export const Contributors = (entry: ContributorProps) => {
  return (
    <>
      {Object.keys(entry)
        .sort()
        .map((key) => {
          const people = entry[key];
          if (people && people.length > 0) {
            return (
              <div className="hbs-article-footer__row" key={key}>
                <h2 className="hbs-article-footer__row-heading">
                  {key.charAt(0).toUpperCase() + key.slice(1)}
                  {people.length > 1 && !key.endsWith("s") ? "s" : ""}:
                </h2>
                <div className="hbs-article-footer__row-content hbs-article-footer__row-content--contributor">
                  {people.map((person, i) => (
                    <ArticleFooterContributorInfo {...person} key={i} />
                  ))}
                </div>
              </div>
            );
          }
          return null;
        })}
    </>
  );
};
